const ITEMS = [
  "SCHATTENPSYCHE",
  "#BOOKTOK",
  "PROFILER-HANDBUCH",
  "BASIS-ANALYSE",
  "MENSCHEN LESEN",
  "#PSYCHOLOGIE",
  "MIMIK & KÖRPERSPRACHE",
  "BAND 1 VON 3",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-white/10 bg-void-soft py-5 overflow-hidden select-none"
      aria-hidden="true"
    >
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center font-typewriter text-sm sm:text-base uppercase tracking-[0.3em] text-slate-500"
              >
                <span className="px-6">{item}</span>
                <span className="text-neon-cyan/60">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
